// extracted by mini-css-extract-plugin
export default {"expertiseStyles":"Expertise_expertiseStyles__Oklbz","images":"Expertise_images__uBTEN"};